import React, { useState, useEffect } from 'react';
import { formatDateTime } from '../../../utils/dateUtils';
import { useDispatch } from 'react-redux';
import { updateHackathon } from '../../../redux/actions/action';
import { updatePrizes } from '../../../redux/actions/action';
import { fetchallAgendas } from '../../../redux/actions/action';
import { useSelector } from 'react-redux';
import { updateAgenda } from '../../../redux/actions/action';
import { toast } from 'react-toastify';


const HackathonEditForm = ({ event, prizes, agendas,onSave, onClose }) => {
  const [eventName, setEventName] = useState('');
  const [technology, setTechnology] = useState('');
  const [projectDetails, setProjectDetails] = useState('');
  const [description, setDescription] = useState('');
  const [eventPlatform, setEventPlatform] = useState('');
  const [duration, setDuration] = useState('');
  const [lastRegistrationDate, setLastRegistrationDate] = useState('');
    const [teamFormation, setTeamFormation] = useState('');
  const [rulesAndGuidelines, setRulesAndGuidelines] = useState('');
  const [firstPrize, setFirstPrize] = useState('');
  const [secondPrize, setSecondPrize] = useState('');
  const [otherPrizes, setOtherPrizes] = useState([]);
  const [agendaItems, setAgendaItems] = useState([]);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const agendasWithId = useSelector((state) => state.fetchAllAgendas.agendasWithId);
  const [selectedAgendaIndex, setSelectedAgendaIndex] = useState(null);



  // Fetch agendas when the component mounts

  useEffect(() => {

    dispatch(fetchallAgendas());

  }, [dispatch]);
  useEffect(() => {
    if (event) {
      setEventName(event.eventName || '');
      setTeamFormation(event.teamFormation || '');
      setTechnology(event.technology|| '');
      setRulesAndGuidelines(event.rulesAndGuidelines || '');
      setDuration(event.duration|| '');
      setLastRegistrationDate(event.lastRegistrationDate||'');
      setProjectDetails(event.projectDetails||'');
      setDescription(event.description||'');
      setEventPlatform(event.eventPlatform||'');
    }
    if (prizes) {
      setFirstPrize(prizes.firstPrize || '');
      setSecondPrize(prizes.secondPrize || '');
      setOtherPrizes(prizes.otherPrizes || []);
    }
  //   if (agendasWithId) {
  //     setAgendaItems(agendasWithId || []);
  //   }
  // }, [event, prizes, agendasWithId]);
  if (agendas) {
    setAgendaItems(agendas || []);
  }
}, [event, prizes, agendas]);

 

  const handleAddPrize = () => {
    setOtherPrizes([...otherPrizes, '']);
  };

  const handlePrizeChange = (index, value) => {
    const updated = [...otherPrizes];
    updated[index] = value;
    setOtherPrizes(updated);
  };

  const handleRemovePrize = (index) => {
    const updated = [...otherPrizes];
    updated.splice(index, 1);
    setOtherPrizes(updated);
  };

  const handleAddAgenda = () => {
    setAgendaItems([...agendaItems, { text: '', date: '' }]);
  };
  
  const handleAgendaChange = (index, field, value) => {
    const updated = agendaItems.map((item, i) => 
      i === index 
        ? { ...item, [field]: field === 'date' ? new Date(value) : value }
        : item
    );
    setAgendaItems(updated);
  };
  
  

  const handleRemoveAgenda = (index) => {
    const updated = [...agendaItems];
    updated.splice(index, 1);
    setAgendaItems(updated);
  };

  console.log("agendas are  for edit "+JSON.stringify(agendas));
  

  const handleSave = () => {
    const newErrors = {};
  
    if (!eventName.trim()) {
      newErrors.eventName = "Event name is required.";
    }
  
    if (!teamFormation.trim() || isNaN(teamFormation) || Number(teamFormation) <= 0) {
      newErrors.teamFormation = "Team Formation must be a positive number.";
    }
  
    if (!rulesAndGuidelines.trim()) {
      newErrors.rulesAndGuidelines = "Rules and Guidelines are required.";
    }
  
    if (!firstPrize.trim()) {
      newErrors.firstPrize = "First prize is required.";
    }
  
    if (!secondPrize.trim()) {
      newErrors.secondPrize = "Second prize is required.";
    }
  
    agendaItems.forEach((item, index) => {
      if (!item.text.trim()) {
        newErrors[`agendaText${index}`] = "Agenda text is required.";
      }
      if (!item.date) {
        newErrors[`agendaDate${index}`] = "Agenda date is required.";
      }
    });
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      alert("Please fix the validation errors.");
      return;
    }
   
  try {
    // Update Hackathon Main Details
    const updatedData = {
      id: event.id,
      eventName,
      technology,
      projectDetails,
      description,
      teamFormation: parseInt(teamFormation, 10),
      rulesAndGuidelines,
      eventPlatform,
      duration,
      lastRegistrationDate,
      //agendas: agendaItems,
    };
   
     dispatch(updateHackathon(updatedData));

    //  agendaItems.forEach((item) => {
    //   if (item.id) {
    //     dispatch(updateAgenda(item.id, {
    //       text: item.text,
    //       date: new Date(item.date).toISOString()
    //     }));
    //   }
    // });

     //dispatch(updateAgenda)
    const hackathonFormId = event.id; // assuming event.id = hackathon_form_id
   
    // update first prize
    dispatch(updatePrizes({
      prize_name: firstPrize,
      rank: 'first',
      hackathon_form_id: hackathonFormId
    }));
    // update second prize
dispatch(updatePrizes({
  prize_name: secondPrize,
  rank: 'second',
  hackathon_form_id: hackathonFormId
}));

otherPrizes.forEach((prizeName, index) => {
  dispatch(updatePrizes({
    prize_name: prizeName,
    rank: 'other',  // fallback rank if more prizes
    hackathon_form_id: hackathonFormId
  }));
});

//dispatch(fetchallAgendas(updatedData));
// useEffect(() => {
//   dispatch(fetchallAgendas());
// }, [dispatch]);

    if (onSave) onSave(updatedData);
    onClose();
    toast.success("Edit details updated successfully!");
  } catch (error) {
    console.error("Error updating:", error);
    toast.error("Failed to update. Please try again.");
  }
};

  return (
    <div className="relative bg-color w-full max-w-3xl mx-auto p-8 rounded-3xl border-4 border-white">
     <div className="max-h-[600px] overflow-y-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Edit Hackathon</h2>
      <div className="space-y-4">
        <div>
          <label className="block mb-1">Event Name</label>
          <input
            type="text"
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1">Team Formation</label>
          <input
            type="text"
            value={teamFormation}
            onChange={(e) => setTeamFormation(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1">Rules and Guidelines</label>
          <textarea
            value={rulesAndGuidelines}
            onChange={(e) => setRulesAndGuidelines(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            rows={4}
          />
        </div>

        {/* Prizes */}
        <div>
          <h3 className="text-xl font-semibold mb-2">🎁 Prizes</h3>

          <div className="mb-2">
            <label className="block mb-1">First Prize</label>
            <input
              type="text"
              value={firstPrize || ''}
              onChange={(e) => setFirstPrize(e.target.value)}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="mb-2">
            <label className="block mb-1">Second Prize</label>
            <input
              type="text"
              value={secondPrize}
              onChange={(e) => setSecondPrize(e.target.value)}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          {/* <div className="mb-2">
            <label className="block mb-1">Other Prizes</label>
            {otherPrizes.map((prize, idx) => (
              <div key={idx} className="flex items-center mb-2 gap-2">
                <input
                  type="text"
                  value={prize}
                  onChange={(e) => handlePrizeChange(idx, e.target.value)}
                  className="w-full border px-3 py-2 rounded"
                />
                <button
                  type="button"
                  onClick={() => handleRemovePrize(idx)}
                  className="bg-red-500 text-white px-2 rounded"
                >
                  ✖
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={handleAddPrize}
              className="mt-2 bg-green-500 text-white px-4 py-1 rounded"
            >
              + Add Prize
            </button>
          </div> */}
        </div>

        {/* Agendas */}
        <div>
          <h3 className="text-xl font-semibold mb-2">🗓️ Agendas</h3>

          {agendaItems.map((item, idx) => (
            <div key={idx} className="flex gap-2 mb-2">
              <input
                type="text"
                placeholder="Agenda Text"
                value={item.text}
                onChange={(e) => handleAgendaChange(idx, 'text', e.target.value)}
                className="flex-1 border px-3 py-2 rounded"
              />
              <input
              type="datetime-local"
                
              value={item.date ? new Date(item.date).toISOString().slice(0, 16) : ''}
                onChange={(e) => handleAgendaChange(idx, 'date', e.target.value)}
                className="border px-3 py-2 rounded"
              />
              {item.id && (
      <button
        type="button"
        onClick={() => {
          dispatch(updateAgenda(item.id, {
            text: item.text,
            date: new Date(item.date).toISOString(),
          }));
          toast.success(`Agenda ID ${item.id} updated`);
        }}
        className="bg-blue-500 text-white px-2 rounded"
      >
        💾
      </button>
    )}
              <button
                type="button"
                onClick={() => handleRemoveAgenda(idx)}
                className="bg-red-500 text-white px-2 rounded"
              >
                ✖
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={handleAddAgenda}
            className="mt-2 bg-green-500 text-white px-4 py-1 rounded"
          >
            + Add Agenda
          </button>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-4 mt-6">
        <button
          onClick={onClose}
          className="bg-gray-400 text-white px-6 py-2 rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-black text-white py-2 px-8 rounded-lg"
        >
          Save
        </button>
      </div>
    </div>
    </div>
  );
};

export default HackathonEditForm;
